/** Lossless alpha runs: save the actual explored boundary, including faint glimpses. */
export function encodeMemoryAlpha(rgba: Uint8ClampedArray): string {
  const bytes: number[] = [];
  const run = (alpha: number, length: number) => {
    bytes.push(alpha);
    do { const part = length & 127; length = Math.floor(length / 128); bytes.push(part | (length ? 128 : 0)); } while (length);
  };
  let alpha = rgba[3] ?? 0, length = 0;
  for (let i = 3; i < rgba.length; i += 4) {
    if (rgba[i] === alpha) length++;
    else { run(alpha, length); alpha = rgba[i]; length = 1; }
  }
  if (length) run(alpha, length);
  let binary = '';
  for (let i = 0; i < bytes.length; i += 8192) binary += String.fromCharCode(...bytes.slice(i, i + 8192));
  return 'alpha1:' + btoa(binary);
}

export function decodeMemoryAlpha(packed: string, pixels: number): Uint8ClampedArray<ArrayBuffer> | null {
  if (!packed.startsWith('alpha1:')) return null;
  let binary: string;
  try { binary = atob(packed.slice(7)); } catch { return null; }
  const rgba = new Uint8ClampedArray(pixels * 4);
  let offset = 0, cursor = 0;
  while (cursor < binary.length) {
    const alpha = binary.charCodeAt(cursor++);
    let length = 0, shift = 0, part: number;
    do {
      if (cursor >= binary.length || shift > 28) return null;
      part = binary.charCodeAt(cursor++);
      length += (part & 127) * 2 ** shift; shift += 7;
    } while (part & 128);
    if (length <= 0 || offset + length > pixels) return null;
    for (const end = offset + length; offset < end; offset++) {
      const i = offset * 4;
      rgba[i] = rgba[i + 1] = rgba[i + 2] = 255; rgba[i + 3] = alpha;
    }
  }
  return offset === pixels ? rgba : null;
}
